// GENERATED FILE - DO NOT MODIFY
export enum DefaultBonusApplyOption {
    TransferringProjectHours = 0,
    DuringTransactionEntry = 1,
}

export let nameof = "DefaultBonusApplyOption";
